import type {Expand} from '../types';

import {courseExpandCommon} from '../course';
import {userExpandCommon} from '../user';

export const coachHistoryExpandCommon: Expand = {
  coach_history: [
    ['client_id', {name: 'Client not found'}, userExpandCommon],
    ['course_id', null, courseExpandCommon],
    [
      'new_coach_id',
      {coach_title: 'Coach not found', name: 'Coach not found'},
      userExpandCommon,
    ],
    [
      'old_coach_id',
      {coach_title: 'Coach not found', name: 'Coach not found'},
      userExpandCommon,
    ],
  ],
};
